<template>
  <div class="customSelectBox">
    <button
      ref="customSelect"
      class="customSelect"
      :class="{open: open, 'default': value == -1}"
      @click="open = !open"
    >
      {{ selected }}
      <span class="icon" :class="open? 'iconUp':'iconDown'" ></span>
    </button>
    <ul
      class="selectOptions"
      :class="{hide: !open}"
    >
      <li
        class="option"
        :class="{'selected': value === idx}"
        v-for="(el, idx) of items"
        :key="idx"
        @click="onChange(idx)"
      >
        {{ el }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  model: {
    event: 'custom-select'
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    firstItem: {
      type: String,
      default: ''
    },
    value: {
      type: Number,
      default: -1
    },
  },
  data() {
    return {
      open: false
    };
  },
  mounted() {
    document.body.addEventListener('click', (event) => {
      const _self = this.$refs.customSelect;
      if(event.target !== _self) {
        this.open = false;
      }
    })
  },
  computed: {
    selected() {
      return this.value >= 0 ? this.items[this.value] : this.firstItem
    },
  },
  methods: {
    onChange: function(value) {
      if (value === '') {
        value = null
      }
      this.$emit('custom-select', value);
      this.open = false
    },
    onClose: function () {
      this.open = false
    }
  },
}
</script>

<style scoped>

</style>
